"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _moment = _interopRequireDefault(require("moment"));

var _ = require("../");

var _sharedInputStyles = require("./sharedInputStyles");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledInputWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n"])), _sharedInputStyles.wrapperStyles);

var StyledInput = _styledComponents.default.input(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n\n  &:not(:focus)::-webkit-datetime-edit-year-field:not([aria-valuenow]),\n  &:not(:focus)::-webkit-datetime-edit-month-field:not([aria-valuenow]),\n  &:not(:focus)::-webkit-datetime-edit-day-field:not([aria-valuenow]) {\n    color: transparent;\n  }\n"])), _sharedInputStyles.inputStyles);

var StyledPlaceholder = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 2px;\n  display: flex;\n  align-items: center;\n  min-height: 30px;\n  min-width: 200px;\n\n  ", ";\n\n  opacity: ", ";\n\n  font-size: ", ";\n  font-family: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n  transform: translateY(-50%);\n  white-space: nowrap;\n  color: ", ";\n  pointer-events: none;\n  background: ", ";\n"])), function (p) {
  return p.theme.inputBorderStyle === "full" && !p.isMandatory && "padding-left: 1rem;";
}, function (p) {
  return p.shouldShow ? 1 : 0;
}, function (p) {
  return p.theme.inputFontSize;
}, function (p) {
  return p.theme.fontFamilyDefault || "inherit";
}, function (p) {
  return p.theme.inputFontStyle;
}, function (p) {
  return p.theme.inputFontWeight;
}, function (props) {
  return props.theme.colorLabel;
}, function (p) {
  return p.theme.inputBackground;
});

var StyledMandatory = _styledComponents.default.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n"])), _sharedInputStyles.mandatoryStyles);

var FormDatePicker = function FormDatePicker(_ref) {
  var name = _ref.name,
      value = _ref.value,
      _ref$format = _ref.format,
      format = _ref$format === void 0 ? "DD/MM/YYYY" : _ref$format,
      label = _ref.label,
      iePlaceholder = _ref.iePlaceholder,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      isError = _ref.isError,
      isMandatory = _ref.isMandatory,
      isFallback = _ref.isFallback,
      hasFullBorder = _ref.hasFullBorder;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1];

  var shouldShowLabel = !focused && value === "" && isFallback;

  var handleFocused = function handleFocused(e) {
    setFocused(true);

    if (onFocus) {
      onFocus(e);
    }
  };

  var handleFallbackOnChange = function handleFallbackOnChange(e) {
    var target = e.target;
    var value = target.value;

    if (value.length === 8) {
      var date = (0, _moment.default)(value, format.replace(/\//g, ""), true);

      if (date.toString() != "Invalid date") {
        e.target.value = date.format(format);
        handleBlurred(e);
      }
    }

    onChange(e);
  };

  var handleBlurred = function handleBlurred(e) {
    setFocused(false);

    if (onBlur) {
      onBlur(e);
    }
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [isFallback ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_.FormTextbox, {
      type: "tel",
      isError: isError,
      isMandatory: isMandatory,
      onChange: handleFallbackOnChange,
      onFocus: handleFocused,
      onBlur: handleBlurred,
      name: name,
      value: value,
      placeholder: shouldShowLabel ? null : iePlaceholder || format.replace(/\//g, "")
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledInputWrapper, {
      hasFullBorder: hasFullBorder,
      isError: isError,
      children: [isMandatory && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledMandatory, {
        children: "*"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledInput, {
        type: "date",
        isMandatory: isMandatory,
        value: value,
        onChange: onChange,
        onFocus: handleFocused,
        onBlur: handleBlurred,
        name: name,
        hasFullBorder: hasFullBorder
      })]
    }), label && /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledPlaceholder, {
      isMandatory: isMandatory,
      shouldShow: shouldShowLabel,
      children: [isMandatory && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledMandatory, {
        style: {
          marginRight: "0.25rem"
        },
        children: "*"
      }), label]
    })]
  });
};

var _default = FormDatePicker;
exports.default = _default;